import JWT from "@/utils/jwt"
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  isLoggedIn: !!JWT.getAccessToken() || false,
  user: {},
  status: null,
  error: null,
  isLoading: false
};

export default {
  namespaced: true,
  state,
  status,
  actions,
  getters,
  mutations,
};